import { withTranslation } from "next-i18next";
import ProductFits from "../Shared/ProductFits";

function ProductRecommendations({ product, t }) {
  if (!product.recommendations) return null;

  return (
    <div className="mb-4">
      <p className="font-weight-bold mb-3">
        {t("product:size_advice_section_title")}
      </p>

      <ProductFits
        product={product}
      />

      <p className="mb-0 font-size-sm">
        {t(`product:${product.recommendations}`)}
      </p>
    </div>
  );
}

export default withTranslation("product")(ProductRecommendations);
